import {createSelector} from "reselect";
import {Reducer} from "redux";
import {ChatAuthenticationActions} from "../actions/chat-authentication-actions";
import {AppRootState} from "./root-reducer";
import { initialChatAuthenticationState } from "../types/chat-authentication-types";

export const chatAuthenticationReducer: Reducer = (state = initialChatAuthenticationState, action) => {
    switch(action.type) {
        case ChatAuthenticationActions.KILL_SWITCH_SET_SUBMIT_OTP_INFO:
            if(action.payload) {
                return {
                    ...state,
                    killSwitchSendOtpInfo: action.payload.killSwitchSendOtpInfo,
                    canClickSubmit: action.payload.canClickSubmit
                }
            }else {
                return {
                    ...state
                }
            }
        case ChatAuthenticationActions.KILL_SWITCH_SET_RESEND_OTP_INFO:
            if(action.payload) {
                return {
                    ...state,
                    killSwitchSendOtpInfo: action.payload.killSwitchSendOtpInfo,
                    canClickResend: action.payload.canClickResend
                }
            }else {
                return {
                    ...state
                }
            }
        case ChatAuthenticationActions.KILL_SWITCH_OTP_RESET:
            return {
                ... state,
                resetOtp: action.payload
            }
        default:
            return state
    }
}

const killSwitchSendOtpInfo = (state: AppRootState) => state.chatAuthenticationReducer.killSwitchSendOtpInfo;
export const getKillSwitchSendOtpInfo = createSelector([killSwitchSendOtpInfo], (data) => data);

const canClickSubmit = (state: AppRootState) => state.chatAuthenticationReducer.canClickSubmit;
export const getCanClickSubmit = createSelector([canClickSubmit], (data) => data);

const canClickResend = (state: AppRootState) => state.chatAuthenticationReducer.canClickResend;
export const getCanClickResend = createSelector([canClickResend], (data) => data);

const resetOtp = (state: AppRootState) => state.chatAuthenticationReducer.resetOtp;
export const getResetOtp = createSelector([resetOtp], (data) => data);